<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav title="NUT" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
				<div class="mt-20 destroy-team-item1-bg-image rounded-20 p-30">
					<div class="flex items-center justify-between">
						<div class="ml-20 flex-1">
							<div class="flex items-center justify-between">
								<span class="text-36 text-white">NUT Token</span>
								<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
									style="border-color:#50B428; background-color: #50B42820;">
									<span class="text-20 text-white">{{$t('NUT.首页.活跃')}}</span>
								</div>
							</div>
							<div class="mt-20">
								<span class="text-24 text-#999">R10{{$t('NUT.首页.下一代DeFi生态代币')}}</span>
							</div>
						</div>
					</div>
					<div class="mt-30 flex items-center justify-between">
						<div class="rounded-20 p-20 flex-1 mr-10" style="background-color: #2D2D2F;">
							<div>
								<span class="text-20 text-white">NUT/ROON</span>
							</div>
							<div class="mt-10">
								<span class="text-36 text-white font-bold">1,420.5</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-success">+12.5%</span>
							</div>
						</div>
						<div class=" rounded-20 p-20 flex-1 ml-10" style="background-color: #2D2D2F;">
							<div>
								<span class="text-20 text-white">NUT/USDR</span>
							</div>
							<div class="mt-10">
								<span class="text-36 text-white font-bold">1,420.5</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-success">+8.3%</span>
							</div>
						</div>
					</div>
				</div>
				<div class="flex items-center justify-between mt-20">
					<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #19191A;">
						<div>
							<img class="w-76 h-76" src="@/assets/images/pages/nut-home/rsc.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-20 text-#ccc">{{$t('NUT.首页.燃烧池')}}</span>
						</div>
						<div class="mt-20">
							<span class="text-40 text-white font-bold">2.5M NUT</span>
						</div>
					</div>
					<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #19191A;">
						<div>
							<img class="w-76 h-76" src="@/assets/images/pages/nut-home/wdc.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-20 text-#ccc">{{$t('NUT.首页.稳定池')}}</span>
						</div>
						<div class="mt-20">
							<span class="text-40 text-white font-bold">8.3M NUT</span>
						</div>
					</div>
				</div>
				<div class="flex items-center justify-between mt-20">
					<div class="flex-1 rounded-20 p-30 mr-10" style="background-color: #19191A;">
						<div>
							<img class="w-76 h-76" src="@/assets/images/pages/nut-home/tdc.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-20 text-#ccc">{{$t('NUT.首页.托底池')}}</span>
						</div>
						<div class="mt-20">
							<span class="text-40 text-white font-bold">1.2M ROON</span>
						</div>
					</div>
					<div class="flex-1 rounded-20 p-30 ml-10" style="background-color: #19191A;">
						<div>
							<img class="w-76 h-76" src="@/assets/images/pages/nut-home/lpjl.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-20 text-#ccc">{{$t('NUT.首页.LP奖励')}}</span>
						</div>
						<div class="mt-20">
							<span class="text-40 text-white font-bold">450K ROON</span>
						</div>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-20" style="background-color: #19191A;">
					<div class="flex items-center justify-between px-20">
						<span class="text-36 text-white font-bold">{{$t('NUT.首页.参与质押')}}</span>
						<div class="flex items-center">
							<span class="text-24 text-#ccc">{{$t('NUT.首页.参与激励')}}</span>
							<img class="w-20 h-20 ml-10" src="@/assets/images/pages/nut-home/more.png" alt="" />
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #272729;">
						<div class="px-10">
							<span class="text-28 text-#999">{{$t('NUT.首页.我的参与统计')}}</span>
						</div>
						<div class="mt-20 flex items-center justify-between px-10">
							<div class="flex-1">
								<div class="">
									<span class="text-20 text-#ccc">{{$t('NUT.首页.总参与')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-32 text-white">1,000</span>
								</div>
							</div>
							<div class="flex-1">
								<div class="">
									<span class="text-20 text-#ccc">{{$t('NUT.首页.份数')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-32 text-white">1,000</span>
								</div>
							</div>
							<div class="flex-1">
								<div class="">
									<span class="text-20 text-#ccc">{{$t('NUT.首页.预计收益')}}</span>
								</div>
								<div class="mt-10">
									<span class="text-32 text-white">1,000</span>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #272729;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-#999">{{$t('NUT.首页.参与数量')}}</span>
							<span class="text-28 text-#999">{{$t('NUT.首页.余额')}}2.500 ROON</span>
						</div>
						<div class="mt-20 h-90 bg-#19191A rounded-20 flex items-center justify-between px-20">
							<input class="w-500 text-50 font-bold text-white" type="text"  placeholder="1,000"/>
							<span class="text-26 text-primary">{{$t('NUT.首页.最大')}}</span>
						</div>
						<div class="mt-20 px-10 flex items-center justify-between">
							<span class="text-28 text-#999">100 RONN  = 1{{$t('NUT.首页.份')}}</span>
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #272729;">
						<div class="px-10 flex items-center justify-between">
							<span class="text-28 text-white">{{$t('NUT.首页.参与规则说明')}}</span>
						</div>
						<div class="mt-20 rounded-20 px-20">
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.首页.1,000 ROON =1份，可多次参与")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.首页.35%全网分红ROON")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.首页.65%自动组LP锁定999年")}}</span>
							</div>
							<div class="py-10 flex items-center">
								<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
								<span class="ml-20 text-24 text-#ccc">{{$t("NUT.首页.全链上执行，透明可查")}}</span>
							</div>
						</div>
					</div>
					<div class="mt-20 rounded-20 p-20" style="background-color: #272729;">
						<div class="px-10 flex items-center">
							<span class="text-28 text-white">{{$t('NUT.首页.收益分配')}}</span>
							<span class="text-28 text-primary">（100ROON）</span>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="flex items-center">
								<img class="w-28 h-28" src="@/assets/images/pages/nut-home/fh.png" alt="" />
								<span class="ml-10 text-28 text-#ccc">{{$t('NUT.首页.全网分红')}}</span>
							</div>
							<span class="ml-10 text-28 text-primary">35 ROON</span>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<div class="flex items-center">
								<img class="w-28 h-28" src="@/assets/images/pages/nut-home/sd.png" alt="" />
								<span class="ml-10 text-28 text-#ccc">{{$t('NUT.首页.组LP锁定')}}</span>
							</div>
							<span class="ml-10 text-28 text-primary">65 ROON</span>
						</div>
						<div class="mt-20 h-60 rounded-12 flex items-center justify-center border border-solid"
							style="border-color:#EB470C; background-color: #EB470C20;">
							<span class="text-20 text-primary">{{$t('NUT.首页.65 ROON中:32.5买入NUT + 32.5 ROON组LP')}}</span>
						</div>
					</div>
					
					<div class="mt-30 rounded-full bg-primary h-100 flex-1 m6-10 flex items-center justify-center">
						<span class="text-white text-32">{{$t('NUT.首页.最少')}} 100 ROON</span>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<menu-bar-nut activeMenu="nut-home"></menu-bar-nut>
		</template>
		<template v-slot:popup>
			
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBarNut from '@/components/menu-bar-nut/menu-bar-nut.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBarNut,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 2
				},
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
		},
		created() {
		},
		methods: {
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	
	.destroy-team-item1-bg-image {
		width: 690rem;
		height: 350rem;
		background-image: url("~@/assets/images/pages/destroy-team/itemBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}
</style>